import {HousingApi} from '../api';
import {FetcherSettings} from '../api/apiClient';

class HousingService {
  housingApi: HousingApi;

  constructor() {
    this.housingApi = new HousingApi();
  }

  getOne(id: string, resolverSettings?: FetcherSettings) {
    return this.housingApi.getOne(id, resolverSettings);
  }

  getLocation(resolverSettings?: FetcherSettings) {
    return this.housingApi.getLocation(resolverSettings);
  }

  getCheckoutSetting(id: string, resolverSettings?: FetcherSettings) {
    return this.housingApi.getCheckoutSetting(id, resolverSettings);
  }
}

export {HousingService};
